import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { environment } from 'src/environments/environment';
import { AuthBagService } from '../auth-bag.service';
import { LoginData, TokenRefreshResponse } from '../auth.model';
import { AuthApiService } from '../auth.api.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
	formError = '';
	readonly data: LoginData = {
		email: null,
		password: null,
	};
	readonly url = environment.passChangeUrl;
	readonly authStatus$ = this.authBagService.authStatus$;

	constructor(
		private readonly authBagService: AuthBagService,
		private readonly loader: LoaderService,
		private readonly authApiService: AuthApiService,
	) {}

	ngOnInit(): void {
		const token = this.authBagService.tokenGet();
		if (token) {
			this.authBagService.erpAuthenticate(token);
		}
	}

	async onSubmit(): Promise<void> {
		this.loader.show();

		try {
			const result: TokenRefreshResponse = await this.authApiService.token(this.data);
			this.formError = '';
			await this.authBagService.authenticate(result);
		} catch (err) {
			this.formError = err.message;
		} finally {
			this.loader.hide();
		}
	}
}
